import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { getIndicator, getIndicatorConfig } from 'utils/common';
import { useText, useFormatNumber } from 'common/hooks';

import Button from 'dc/Button';
import {
  Container,
  ProgressCircle,
  TextWrapper,
  Text,
  Link,
  Title,
} from './elements';
import EditBar from '../common/EditBar';
import { InsightsButton } from '../common/elements';

const deps = {
  currentGoal: state.challenge.info.computedCurrentGoal,
  goals: state.challenge.info.computedGoals,
  indicator: state.challenge.campaign.indicator,
  totalUserStats:
    state.challenge.stats.total.profiles[state.appContainer.user.uid],
  currentTab: state.challenge.currentTab,
  goalModalClicked: sequences`challenge.info.goalModalClicked`,
  tabClicked: sequences`challenge.tabMenuClicked`,
};

export function CompletedGoal({
  currentGoal,
  goals,
  totalUserStats,
  currentTab,
  goalModalClicked,
  tabClicked,
  indicator,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const totalUserSavings = getIndicator(totalUserStats, indicator);
  const formatNumber = useFormatNumber();
  const { unitPath } = getIndicatorConfig(indicator);

  const { goal } = currentGoal;

  const formattedGoal = formatNumber(goal.score / 1_000_000);

  return (
    <Container>
      <EditBar />
      <ProgressCircle
        indicator={indicator}
        totalUserSavings={totalUserSavings}
        userGoal={goal.score / 1_000_000}
      />
      <TextWrapper>
        <Title>{t(`challenge.goal_achieved.${goal.level}.title`)}</Title>
        <Text>
          {t(`challenge.goal_achieved.${goal.level}.text`, {
            goal: formattedGoal,
            unit: t(unitPath),
          })}
        </Text>
        {goals.some(g => g.canBeSet) && (
          <Button onClick={() => goalModalClicked()}>
            <Link>
              {t('challenge.ChaPaD24B.PersonalInsights.goals.set_a_new_goal')}
            </Link>
          </Button>
        )}
      </TextWrapper>
      <InsightsButton
        disabled={currentTab === 2}
        onClick={() => tabClicked({ tab: 2, currentTab })}
      >
        {t('challenge.ChaPaD24B.PersonalInsights.goals.view_impact')}
      </InsightsButton>
    </Container>
  );
}

export default connect(deps, CompletedGoal);
